import axios from 'axios';
import store from '../../store';
import { getUrlParam } from '../common'
import enCode from "../encode"; // AES 
import createUuid from "../uuid"; // uuid 


export default function share(info) {
  function getJsTiket(encrypt) {
    let platform = getUrlParam('platform')
    const data = {
      "body": {
        "encrypt": encrypt,
        appid: process.env.APPID,
        url: location.href.split('#')[0]
      },
      "brand": platform ? platform : 'web',
      "guid": createUuid(),
      "model": platform ? platform : 'web',
      "platform": platform ? platform : 'web',
      "sysVersion": "7.1.1",
      "time": parseInt(+new Date() / 1000),
      "uid": '',
      "version": '1.2.2',
      "isJailBreak": false,
      "isSimulator": false,
      "session": ''
    }
    console.log(data,'data-----')
    return axios({
      method: 'post',
      url: 'https://api.yishengzhan.cn/gw/wechat/getJsticket',
      data: enCode.encodeFunc(data)
    })
    // return axios({
    //   method: 'post',
    //   url: `${process.env.API_HOST}/wx/mp/${process.env.APPID}/sign`,
    //   data: { url: location.href.split('#')[0] },
    //   headers: {
    //     encrypt: store.getters['user/encrypt'],
    //   },
    //   dataType: 'json',
    // });
  }
  const userInfo = store.getters['user/userInfo'];
  const encrypt = store.getters['user/encrypt'];
  const platform = store.getters.platform;
  console.log(platform,'platform')
  const userAgent = navigator.userAgent;

  if (/MicroMessenger/i.test(userAgent)) {
    getJsTiket(encrypt)
      .then((res) => {
        var data = JSON.parse(enCode.decodeFuc(res.data.data))
        
        console.log(data,'-------------res')
        // const signParams = Object.assign({}, res.data.data, {
        const signParams = Object.assign({}, data.body, {
          debug: false,
          jsApiList: [
            'onMenuShareAppMessage',
            'onMenuShareTimeline',
            'hideOptionMenu',
            'updateTimelineShareData',
            'updateAppMessageShareData',
            "startRecord", //开始录音
            "stopRecord", //停止录音
            "onVoiceRecordEnd", //监听录音自动停止接口
            "playVoice", //播放录音
            "pauseVoice", //暂停云隐接口
            "stopVoice", //停止播放
            "onVoicePlayEnd", //
            "uploadVoice", //上传语音
            "downloadVoice" //下载语音
          ],
        });
        signParams.appId = process.env.APPID
        wx.config(signParams);
        wx.ready(() => {
          const params = {
            title: info.title,
            desc: info.desc,
            link: info.link,
            imgUrl: info.imgUrl,
            success(res) {
              console.log(res)
            },
          };
          wx.onMenuShareAppMessage(params);
          wx.onMenuShareTimeline(params);
        });
      });
  } else {
    const u = navigator.userAgent;
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

    const GetQueryString = function (name) {
      const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
      const r = window.location.search.substr(1).match(reg);
      if (r != null) return (r[2]);
      return null;
    };
    if (isAndroid) {
        /* 方法_设置是否拦截TitleBar上面的点击事件 */
      const args = {
        flag: true,
      };
      dsBridge.call('view.setInterceptBarEvent', JSON.stringify(args));
      const shareInfo = {
        title: info.title,
        brief: info.desc,
        shareUrl: info.link,
        shareImg: info.imgUrl,
      };
      dsBridge.call('view.setBarRightText', JSON.stringify({
        text: '分享',
      }));
      dsBridge.register('view', {
        tag: 'view',
        onRightClick() {
          dsBridge.call('share.share', JSON.stringify(shareInfo));
        },
      });
    } else if (isIOS) {
      const hasBuildScript = document.getElementById('IOS_getShareInfoOC');
      if (hasBuildScript) {
        document.body.removeChild(hasBuildScript);
        const scriptTitle = document.createElement('script');
        scriptTitle.id = 'IOS_getShareInfoOC';
        scriptTitle.innerHTML = `try{window.webkit.messageHandlers.getShareInfoOC.postMessage({title:"${info.title}",brief:"${info.desc}",shareUrl:"${info.link}",shareImage:"${info.imgUrl}"});}catch(e){}`;
        document.body.appendChild(scriptTitle);
      } else {
        const scriptTitle = document.createElement('script');
        scriptTitle.id = 'IOS_getShareInfoOC';
        scriptTitle.innerHTML = `try{window.webkit.messageHandlers.getShareInfoOC.postMessage({title:"${info.title}",brief:"${info.desc}",shareUrl:"${info.link}",shareImage:"${info.imgUrl}"});}catch(e){}`;
        document.body.appendChild(scriptTitle);
      }
    }
    else {
      console.log('pc');
    }
  }
}
  


// WEBPACK FOOTER //
// ./src/utils/bridge/share.js